import React from "react";
import { Link } from "react-router-dom";

function AdapterLink(props, ref) {
  return <Link innerRef={ref} {...props} />;
}

export default React.forwardRef(AdapterLink);
